"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const sectors = [{
  id: "aerospace",
  title: "Ավիատիեզերական Ընկերություններ Եվ Անվտանգություն",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/aerospace_security_sector.png",
  className: "md:col-span-2 md:row-span-2 h-[200px] md:h-full",
  titleClassName: "absolute inset-0 p-4 flex flex-col justify-end"
}, {
  id: "research",
  title: "Ուսումնական Եվ Գիտահետազոտական Կենտրոններ",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/research_centers_sector.png",
  className: "md:col-span-1 md:row-span-1 h-[200px]"
}, {
  id: "agriculture",
  title: "Գյուղատնտեսություն",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/agriculture_sector.png",
  className: "md:col-span-1 md:row-span-1 h-[200px]"
}, {
  id: "mining",
  title: "Հանքարդյունաբերություն",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/mining_sector.png",
  className: "md:col-span-1 h-[200px]"
}, {
  id: "environment",
  title: "Շրջակա Միջավայր Եվ Աղետների Կառավարում",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/environment_management_sector.png",
  className: "md:col-span-1 h-[200px]"
}, {
  id: "energy",
  title: "Էներգետիկա Եվ Տելեկոմ",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/energy_telecom_sector.png",
  className: "md:col-span-1 h-[200px]"
}, {
  id: "finance",
  title: "Ֆինանսներ, Բանկեր Եվ Ապահովագրություն",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/finance_insurance_sector.png",
  className: "md:col-span-1 h-[200px]"
}, {
  id: "logistics",
  title: "Լոգիստիկա",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/logistics_sector.png",
  className: "md:col-span-1 h-[200px]"
}, {
  id: "journalism",
  title: "Ժուռնալիստիկա",
  image: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/image242.png?v=yla79f3xn8b",
  className: "md:col-span-1 h-[200px]"
}];
export default function HeritageHospitality() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.05
  });
  return <section data-section-id="223889" id="ոլորտներ" className="bg-slate-50 text-foreground relative w-full py-16 px-4 overflow-hidden scroll-smooth">
      <div className="absolute inset-0 z-0 opacity-[0.05] pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/orbital_grid_pattern.png)] bg-repeat" aria-hidden="true" />

      <div id="heritage-hospitality" className="container mx-auto px-4 relative z-10">
        <div ref={headerRef} className={`max-w-4xl mx-auto text-center mb-12 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight text-blue-900 uppercase mb-6 leading-tight">&nbsp;ՄԵՐ ՆՈՐԱՐԱՐԱԿԱՆ ԼՈՒԾՈՒՄՆԵՐը</h2>
          <div className="w-12 h-1 bg-blue-900 mx-auto" />
        </div>

      <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 gap-4 transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {sectors.map((sector, i) => <Link key={i} to={`#${sector.id}`} data-index={i} className={`block group relative overflow-hidden rounded-lg border border-border/20 bg-card transition-all duration-500 hover:border-primary/50 hover:shadow-lg hover:shadow-primary/10 ${sector.className}`}>
              <div className="absolute inset-0 w-full h-full transition-transform duration-700 group-hover:scale-110">
                <img src={sector.image} data-wvc-srcset={`${sector.image}-wvc-srcset`} data-wvc-sizes={`${sector.image}-wvc-sizes`} alt={sector.title} className="w-full h-full object-cover" loading="lazy" decoding="async" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-80 group-hover:opacity-60 transition-opacity" />
              </div>

              <div className={`${sector.titleClassName || ""} absolute inset-0 p-4 flex flex-col justify-end`}>
                <h3 className="text-white font-default text-lg md:text-xl font-bold leading-tight tracking-tight drop-shadow-md group-hover:text-primary transition-colors">
                  {sector.title}
                </h3>
                <div className="w-0 group-hover:w-12 h-[2px] bg-primary mt-3 transition-all duration-500" />
              </div>

              <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <div className="text-[10px] font-mono text-primary/70 uppercase tracking-widest">
                  
                </div>
              </div>
            </Link>)}
        </div>
      </div>
    </section>;
}